import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderBy',
  pure: false // This ensures the pipe is called every time change detection runs
})
export class OrderByPipe implements PipeTransform {
  transform(array: any[], sortExpressions: string | string[]): any[] {
    if (!array || !sortExpressions || !sortExpressions.length) {
      return array; // Return the original array if no sorting is needed
    }

    return array.sort((a, b) => {
      for (let sortExpr of sortExpressions) {
        const [property, order = 'asc'] = sortExpr.split(':');
        const aValue = a[property];
        const bValue = b[property];

        if (aValue !== bValue) {
          const sortOrder = order === 'desc' ? -1 : 1;
          return aValue > bValue ? sortOrder : -sortOrder;
        }
      }
      return 0;
    });
  }
}
